module.exports = __webpack_public_path__ + "static/img/pic4.9cec09a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case2/pic4.jpg
// module id = zgoz
// module chunks = 1